var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadCloud = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 64,
  viewBox: "0 0 96 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M77.4 24.16C74.68 10.36 62.56 0 48 0C36.44 0 26.4 6.56 21.4 16.16C9.36 17.44 0 27.64 0 40C0 53.24 10.76 64 24 64H76C87.04 64 96 55.04 96 44C96 33.44 87.8 24.88 77.4 24.16ZM56 36V52H40V36H28L48 16L68 36H56Z",
  fill: "#DEDEDE"
})));
export { SvgUploadCloud as ReactComponent };
export default __webpack_public_path__ + "cc0036c8d8bf27df933729a57b671c5f.svg";